import { render, staticRenderFns } from "./MaizeDetailsForm.vue?vue&type=template&id=074acd06&scoped=true&"
import script from "./MaizeDetailsForm.vue?vue&type=script&lang=js&"
export * from "./MaizeDetailsForm.vue?vue&type=script&lang=js&"
import style0 from "./MaizeDetailsForm.vue?vue&type=style&index=0&id=074acd06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074acd06",
  null
  
)

export default component.exports